//React
import React from 'react';

// Tanstack Query
import { QueryClient } from '@tanstack/react-query';

// Pages
import { ClaimManagement } from 'pages/claims';

// Store
import { useProviderClaimManagementData } from './useProviderClaimManagementData';

interface UserClaimManagementProps {
  queryClient: QueryClient;
}

export const ProviderClaimManagement: React.FC<UserClaimManagementProps> = ({
  queryClient,
}) => {
  const {
    claims,
    claimStatusesCount,
    providers,
    sites,
    status,
    payors,
    eobs,
    eobCounts,
    actionRequestsCount,
    remittances,
    isLoading,
    isError,
    isFetching,
    errorMessage,
    pagination,
    setPagination,
    refetchClaims,
    refetchStatusesCount,
    invalidData,
    loadEobLookups,
  } = useProviderClaimManagementData(queryClient);

  return (
    <ClaimManagement
      claims={claims}
      claimStatuses={claimStatusesCount}
      providers={providers}
      sites={sites}
      status={status}
      payors={payors}
      remittances={remittances}
      eobs={eobs}
      eobCounts={eobCounts}
      providerActionRequestCount={actionRequestsCount}
      isLoading={isLoading}
      isError={isError}
      isFetching={isFetching}
      setPagination={setPagination}
      pagination={pagination}
      invalidData={invalidData}
      errorMessage={errorMessage}
      refetchClaims={refetchClaims}
      refetchStatusesCount={refetchStatusesCount}
      loadEobLookups={loadEobLookups}
      queryClient={queryClient}
    />
  );
};
